import { Stack } from "@altimateai/lego";
import PrivacyBadge from "@/components/badges/PrivacyBadge";
import { useUsers, useTenantInfo } from "@/helpers/hooks";
import { Privacy } from "@/helpers/constants";
import { PrivacyLevel } from "@/types";

interface PrivacyAndCreatorInfoProps {
  privacy: PrivacyLevel;
  userId?: number;
  showCreator?: boolean;
  className?: string;
}

export default function PrivacyAndCreatorInfo({
  privacy,
  userId,
  showCreator = true,
  className = "",
}: PrivacyAndCreatorInfoProps) {
  const { getById: getUserById } = useUsers();
  const { enableAdvancedGuardRails } = useTenantInfo();
  
  if (!enableAdvancedGuardRails) {
    return null;
  }

  const getCreatorName = (userId: number) => {
    const user = getUserById(userId);
    if (user) {
      return `${user.first_name} ${user.last_name}`.trim();
    }
    return `User #${userId}`;
  };

  return (
    <Stack align="center" className={className}>
      <PrivacyBadge privacy={privacy || Privacy.PRIVATE} />
      {showCreator && userId && privacy !== Privacy.PRIVATE && (
        <div className="al-text-xs al-text-gray-500">
          Created by: {getCreatorName(userId)}
        </div>
      )}
    </Stack>
  );
}